function InventoryControls() {
    "use strict";

    this.ListView = null;
    this.ListViewFilter = null;
    this.ListViewPaginator = null;
    this.CardView = null;
    this.CardViewFilter = null;
    this.CardViewPaginator = null;
    this.Map = null;
    this.PopupView = null;

    // Devices
    this.DevicesAssignmentListView = null;
    this.DevicesContactHistoryListView = null;

    // Device Clusters
    this.DeviceClusterDeviceListView = null;
    this.DeviceClusterDeviceEditListView = null;
    this.DeviceClusterEnrolleeListView = null;
    this.DeviceClusterEnrolleeEditListView = null;
    this.DeviceClusterValidator = null;

    this.InventoryTilePaginator = null;
    this.TileAnalysisCardView = null;
    this.TileAnalysisCardViewFilter = null;

    //chartjs holder
    this.chartInstance = null;
}
if (typeof exports !== 'undefined') {
    module.exports = InventoryControls;
}